import React from "react";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { classColor } from "@/lib/format";

const MEDAL = ["#fab20b", "#c0c8d4", "#cd7f32"];

export function SupplierLeaderboard({ data, onSelect, selectedId }) {
  if (!data) return null;
  return (
    <div className="space-y-1.5" data-testid="supplier-leaderboard">
      {data.map((s, i) => {
        const medal = MEDAL[i];
        const active = s.id === selectedId;
        return (
          <motion.button
            key={s.id}
            initial={{ opacity: 0, x: -8 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.05 }}
            onClick={() => onSelect && onSelect(s.id)}
            data-testid={`leaderboard-row-${s.id}`}
            className={`w-full flex items-center gap-3 px-3 py-2.5 panel-2 text-left transition-colors duration-200 border-l-2 ${active ? "border-brand-green bg-surface-2" : "hover:border-brand-green/50"}`}
            style={{ borderLeftColor: medal || "rgba(139,161,192,0.2)" }}
          >
            <div className="w-7 text-center">
              {i < 3 ? <Trophy size={16} style={{ color: medal }} /> :
                <span className="text-sm font-mono text-ink-soft">{s.rank}</span>}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-display font-bold text-sm uppercase tracking-tight text-ink truncate">{s.name}</div>
              <div className="text-[0.66rem] text-ink-soft font-mono">{s.mine} · {s.source}</div>
            </div>
            <div className="text-right">
              <div className="text-lg font-bold tnum text-ink">{s.spi}</div>
              <span className="text-[0.6rem] font-bold uppercase tracking-wider font-mono" style={{ color: classColor(s.classification) }}>
                {s.classification}
              </span>
            </div>
          </motion.button>
        );
      })}
    </div>
  );
}
